import { withStyles } from "@material-ui/core";
import React, {memo} from "react";
import { compose } from "recompose";
import Tooltip from "../../../components/common/StyledToolTip";
import { PICKUP_MANAGEMENT_MODES } from "../../../components/modules/Dispatch/RouteExecution/Pickups/PickupManagement/constants";
import styles from "./styles";
import MergeIcon from "@material-ui/icons/CallMerge";
import { isFuturePickup } from "../../../components/modules/Dispatch/RouteExecution/filterUtils";
import { withUserProfile } from "../../../userProfile/userProfileContext";

class MergePickup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
    this.isPickupSelectionInvalid = false;
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeMergePickupStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updatePickupManagementIconStatus`,
      this.changeMergePickupStatus
    );
  }

  changeMergePickupStatus = ({
    selectedPickups,
    terminalOffset
  }) => {
    this.isPickupSelectionInvalid = selectedPickups.some(
      (pickup) =>
        pickup.isCompleted ||
        pickup.isVoided ||
        isFuturePickup(
          pickup.pickupDate,
          terminalOffset
        )
    );
    const isMergePickupEnabled = selectedPickups.length > 1 && !this.isPickupSelectionInvalid;
    this.setState({
      enable: isMergePickupEnabled,
    });
  };

  getTooltipMessage = () => {
    if (this.props.enableMergePickup && this.state.enable) {
      return "Click to Merge Pickup";
    }
    if (!this.props.enableMergePickup || this.isPickupSelectionInvalid) {
      return "Merge Pickups (Disabled)";
    }
    return "Select at least two pickups to merge";
  };

  onMergePickupEvent = () => {
    if (this.props.enableMergePickup && this.state.enable) {
      this.props.eventHub.emit("pickupManagement", {
        action: PICKUP_MANAGEMENT_MODES.MERGE_PICKUP,
      });
    }
  };

  render() {
    const { classes , enableMergePickup} = this.props;
    const { enable } = this.state;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          enableMergePickup && enable
            ? classes.enabledIcon
            : classes.disableIcon
        }`}
        onClick={this.onMergePickupEvent}
      >
        <Tooltip title={this.getTooltipMessage()}>
          <MergeIcon />
        </Tooltip>
      </div>
    );
  }
}

export default compose(withUserProfile,withStyles(styles))(memo(MergePickup));
